import { IconComponentWrapper } from "../scripts/generate-icons/icon-component-wrapper";
import type { IconProps } from "../scripts/generate-icons/ticon-component-wrapper";

function IconComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={36}
      height={24}
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x={0.75} y={0.75} width={34.5} height={22.5} fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3832 20.0508H19.0688C23.261 20.0508 26.6016 16.7249 26.7326 12.6165V12.5512C26.6671 8.37759 23.261 4.98649 19.0688 5.05171H16.0557C12.06 5.18213 8.91591 8.57323 9.04692 12.6165C9.04692 16.6597 12.322 19.9856 16.3832 20.0508ZM10.3574 12.5507C10.3574 9.15964 13.174 6.35547 16.5802 6.35547C19.9863 6.35547 22.8029 9.15964 22.8029 12.5507C22.8029 15.9418 19.9863 18.746 16.5802 18.746C13.174 18.746 10.3574 15.9418 10.3574 12.5507ZM17.5625 16.7255V8.44336C19.8551 9.03028 21.2962 11.3127 20.7066 13.5952C20.3136 15.1603 19.1346 16.3342 17.5625 16.7255ZM12.5182 11.5084C11.9287 13.7909 13.3043 16.1385 15.5969 16.7255V8.44336C14.0903 8.83464 12.9113 10.0085 12.5182 11.5084Z"
        fill="#0079BE"
      />
      <rect
        x={0.75}
        y={0.75}
        width={34.5}
        height={22.5}
        stroke="#CBD5E1"
        strokeWidth={1.5}
      />
    </svg>
  );
}
const IconComponentWrapped = (props: IconProps) => {
  return (
    <IconComponentWrapper data-testid="icon-diner" {...props}>
      <IconComponent />
    </IconComponentWrapper>
  );
};
export default IconComponentWrapped;
